<template>
    <div class="temp-container">
        <div class="maps">
            <div class="hotPic" id="heatmap" style="width:375px; height: 2600px; position: absolute; z-index: 1000; top: 65px">
              <canvas
                  :ref="'refmyCanvas'"
                  style="z-index: 1002;position: absolute; left: 0px; top: 0px;"
                  class="canvasClass"
                  :width="cavWidth"
                  :height="cavHeight"
                  @mousedown="canvasMouseDown"
                  @mouseup="canvasMouseUp"
                  @mousemove="canvasMouseMove">
              </canvas>
              <div class="area-heatmap-wrapper" :style="{ top: areaTop + 'px', left: areaLeft + 'px' }" v-if="areaHeatmapFlag">
                <div class="flex item-center flex-between content-wrapper">
                  <span>点击次数</span>
                  <span>{{ areaHeatmap.clickNum }}</span>
                </div>
                <div class="flex item-center flex-between content-wrapper">
                  <span>点击人数</span>
                  <span>{{ areaHeatmap.clickMember }}</span>
                </div>
                <div class="flex item-center flex-between content-wrapper">
                  <span>点击率</span>
                  <span>{{ areaHeatmap.ctr }}%</span>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>
<script>
    import heatmap from 'heatmap.js'
    import {getCookie} from "@/utils/utils";

    export default {
        props:{
            hotMapTime:{
                type:Object,
                required:false
            },
            visitPv:{
              type: Number,
              default: 0
            }
        },
        data(){
            return{
                points: [],       // 热力图数据存放数组
                cavWidth: null,    //获取宽度
                cavHeight: null,    //获取高度
                point:{
                    x: 15, // x coordinate of the datapoint, a number(x坐标)
                    y: 53, // y coordinate of the datapoint, a number（y坐标）
                    value: 500 // the value at datapoint(x, y)
                },
              params: {
                currentX: 0,
                currentY: 0,
                flag: false, // 用来判断在canvas上是否有鼠标down的事件，
                editFlag: false,
                editIndex: -1
              },
              // 目标类别list
              imageCategoryList: [],
              targetMarkArray: [],
              targetMarkIndex: -1,// 目标标注index
              cxt: "",
              areaHeatmapFlag: false,
              mapList: [],
              areaHeatmap: {
                clickNum: 0,
                clickMember: 0,
                ctr: 0,
              },
              areaTop: 0,
              areaLeft: 0,
            }
        },

        created(){
        },
        mounted(){
            this.initValue().then(res=>{
                this.initHotPic();
            })
            this.getRectValue();
            //canvas对象初始化
            let c = this.$refs.refmyCanvas;
            this.cxt = c.getContext('2d');

            this.progressDom = document.getElementsByClassName('progress_list')
            var _this = this
            window.onresize = () => {
                return (() => {
                    _this.cavWidth = document.getElementById("heatmap").clientWidth;
                    _this.cavHeight = document.getElementById("heatmap").clientHeight;
                })()
            }
        },
        watch:{
            cavWidth:{
                handler(curVal, oldVal) {
                    let _this = this;
                    _this.cavWidth = curVal;
                    if (oldVal != 0 && oldVal!=null) {
                        for (let i = 0; i < this.points.length; i++) {
                            this.points[i].x = Number((this.points[i].x * curVal / oldVal).toFixed(0));
                        }
                        _this.initHotPic();
                    }
                    // console.log("宽=" + curVal, oldVal);
                },
            },
            cavHeight:{
                handler(curVal, oldVal) {
                    var _this = this;
                    _this.cavHeight = curVal;
                    if (oldVal != 0 && oldVal!=null) {
                        for (var i = 0; i < this.points.length; i++) {
                            this.points[i].y = Number((this.points[i].y * curVal / oldVal).toFixed(0));
                            console.log(this.points[i].y)
                        }
                        _this.initHotPic();
                    }
                    // console.log("高=" + curVal, oldVal);
                },
            }
        },
        methods:{
            // 初始化获取宽高(考虑到后期的适配，获取父级元素的宽高)
            getRectValue(){
                this.cavWidth = document.getElementById("heatmap").clientWidth;
                this.cavHeight = document.getElementById("heatmap").clientHeight;
                console.log(this.cavWidth,this.cavHeight)
            },
            // 初始化获取数据（模拟的展示数据）
            async initValue(){
            let layouid = getCookie({key:"layId"})
            const result = await this.$store.dispatch("hotmap",{
                pageId:layouid,
                startTime:this.hotMapTime.startTime,
                endTime:this.hotMapTime.endTime
            });
            this.mapList = result.result;
            let point = [];
                result.result.forEach(v =>{
                    point.push({
                       x:Math.floor(v.x),
                       y:Math.floor(v.y),
                       value:v.clickNum * 50
                    });
                    this.points = point;

                });
                console.log(this.points);
                // var len = 30
                // while (len--) {
                //     var val = Math.floor(Math.random() * 100)
                //     // max = Math.max(max, val)
                //     var pointss = {
                //         x: Math.floor(Math.random() * 375),
                //         y: Math.floor(Math.random() * 2500),
                //         value: val
                //     }
                //     this.points.push(pointss)
                // }

            },
            // 初始化热力图
            initHotPic(){
                this.deleteHotMap()
                let self = this
                let heatmapInstance = heatmap.create({
                    container: document.getElementById('heatmap'),
                    gradient: {//渐变颜色
                        "0": "rgba(255,255,255,1)",//value为0的颜色
                        "0.3": "#82ff6d",//value为500的颜色
                        "0.8": "#f3ff6d",//value为1000的颜色
                        "1": "#ff6d6d",//value为2000的颜色
                    },
                    radius: 10,
                    maxOpacity: 0.5,
                    minOpacity: 0.001,
                    // maxOpacity: 1,
                    // minOpacity: 0,
                    blur: 0.9,
                    // radius:30, //半径
                    // opacity:0.5, //透明
                    // maxOpacity, //热图中最大值具有的最大不透明度
                    // minOpacity, //热图中最小值的最小不透明度
                    // onExtremaChange, //传递回调以接收极值更改更新
                    // blur, //将应用于所有数据点的模糊因子。模糊因子越高，渐变将越平滑
                    // xField, //数据点中x坐标的属性名称
                    // yField, //数据点中y坐标的属性名称
                    // valueField //数据点中y坐标的属性名称
                })

                let max = 0

                // var width = 600

                // var height = 400
                let data = {
                    max: 100,     //数据对比(max和min进行数据对比，从而展示热力颜色)
                    min:0,
                    data: self.points

                }
                heatmapInstance.setData(data)
            },
            // 删除之前的热力图
            deleteHotMap(){
                let heatmapBox = document.getElementById("heatmap");
                if(heatmapBox.children.length>1){
                    let oldCanvas = heatmapBox.children[1];
                    heatmapBox.removeChild(oldCanvas);
                }
            },
            selectPreviewItem(i, prop) {
                console.log(i);
                console.log(prop);
                this.activePreviewIndex = i;
                this.currentProp = {};
                this.currentProp = prop;
                this.showPageSetting = false;
            },
          // 鼠标down事件
          canvasMouseDown(e) {
            if (this.targetMarkArray && this.targetMarkArray.length) {
              this.clearCanvasOnDrawBg();
              this.targetMarkArray = [];
              this.targetMarkIndex =  -1;
            }
            this.canvasOnDrawBg();
            this.params.flag = true;
            if (!e) {
              e = window.event;
              // 防止IE文字选中
              this.$refs.refmyCanvas.onselectstart = function() {
                return false;
              };
            }
            // 这里先判断一下，看是否是在有效数据，并且初始化参数
            if (this.params.flag === true) {
              this.params.currentX = 0;
              this.params.currentY = 0;
              this.params.currentX = e.layerX;
              this.params.currentY = e.layerY;
              const dict1 = {
                x1: this.params.currentX, // 开始的x坐标
                y1: this.params.currentY, // 开始的y坐标
                x2: this.params.currentX, // 结束的x坐标
                y2: this.params.currentY, // 结束的y坐标
                flag: false, // 图片区域是否高亮,
                targetMarkValue: '', // 目标类别值
                wid: 0, // 矩形宽度
                hei: 0, // 矩形高度
                // final 是最终的框选的坐标值
                left: this.params.currentX,
                top: this.params.currentY,
                width: 0, // 矩形宽度
                height: 0, // 矩形高度
                finalX1: this.params.currentX,
                finalY1: this.params.currentY,
                finalX2: this.params.currentX,
                finalY2: this.params.currentY
              };
              this.targetMarkIndex = this.targetMarkIndex + 1;
              this.targetMarkArray.push(dict1);
            }
            // 执行渲染操作
            try {
              this.canvasOnDraw(this.cavWidth, this.cavHeight);
            } catch (err) {
              console.log(err);
            }
          },
          canvasMouseUp(e) {
            this.params.flag = false;
            this.clearCanvasOnDrawBg();
            this.canvasOnDrawBg();
            try {
              this.clearCanvasOnDraw(this.cavWidth, this.cavHeight);
            } catch (err) {
              console.log(err);
            }
          },
          canvasMouseMove(e) {
            if (e === null) {
              e = window.event;
            }
            if (this.params.flag === true) {
              this.params.currentX = e.layerX;
              this.params.currentY = e.layerY;
              this.targetMarkArray[this.targetMarkIndex].x2 = this.params.currentX; // x1 值
              this.targetMarkArray[this.targetMarkIndex].y2 = this.params.currentY; // y1 值
              this.targetMarkArray[this.targetMarkIndex].wid = this.params.currentX - this.targetMarkArray[this.targetMarkIndex].x1; // 宽度值
              this.targetMarkArray[this.targetMarkIndex].hei = this.params.currentY - this.targetMarkArray[this.targetMarkIndex].y1; // 高度
              // 执行渲染操作
              try {
                this.canvasOnDraw(this.cavWidth, this.cavHeight);
              } catch (err) {
                console.log(err);
              }
            }
          },
          // canvas绘图选中部分
          canvasOnDraw() {
            if (this.targetMarkArray && this.targetMarkArray.length) {
              this.cxt.fillStyle = "rgba(255,255,255,0.1)";
              this.cxt.fillRect(this.targetMarkArray[this.targetMarkIndex].x1, this.targetMarkArray[this.targetMarkIndex].y1,
                  this.targetMarkArray[this.targetMarkIndex].wid, this.targetMarkArray[this.targetMarkIndex].hei);
            }
          },
          // canvas绘制背景
          canvasOnDrawBg() {
            this.cxt.fillStyle = "rgba(0,0,0,0.5)";
            this.cxt.fillRect(0, 0, this.cavWidth, this.cavHeight);
          },
          // canvas清除选中区域
          clearCanvasOnDraw() {
            this.cxt.clearRect(this.targetMarkArray[this.targetMarkIndex].x1, this.targetMarkArray[this.targetMarkIndex].y1,
                this.targetMarkArray[this.targetMarkIndex].wid, this.targetMarkArray[this.targetMarkIndex].hei);
            if (this.targetMarkArray[this.targetMarkIndex].wid === 0 && this.targetMarkArray[this.targetMarkIndex].hei === 0) {
              this.areaHeatmapFlag = false;
              this.clearCanvasOnDrawBg();
            } else {
              this.clacAreaHeatmap();
            }
          },
          // canvas清除背景
          clearCanvasOnDrawBg() {
            this.cxt.clearRect(0, 0, this.cavWidth, this.cavHeight);
          },
          async clacAreaHeatmap() {
            let xMin = Math.min(this.targetMarkArray[this.targetMarkIndex].x1, this.targetMarkArray[this.targetMarkIndex].x2);
            let xMax = Math.max(this.targetMarkArray[this.targetMarkIndex].x1, this.targetMarkArray[this.targetMarkIndex].x2);
            let yMin = Math.min(this.targetMarkArray[this.targetMarkIndex].y1, this.targetMarkArray[this.targetMarkIndex].y2);
            let yMax = Math.max(this.targetMarkArray[this.targetMarkIndex].y1, this.targetMarkArray[this.targetMarkIndex].y2);
            let layouid = getCookie({key:"layId"})
            const result = await this.$store.dispatch("heatMapArea", {
              pageId:layouid,
              startTime:this.hotMapTime.startTime,
              endTime:this.hotMapTime.endTime,
              minXAxis: xMin,
              maxXAxis: xMax,
              minYAxis: yMin,
              maxYAxis: yMax,
            })
            console.log("result", result);
            this.areaHeatmap.clickNum = result.result.clickPv;
            this.areaHeatmap.clickMember = result.result.clickUv;
            this.areaHeatmap.ctr = this.visitPv && this.visitPv != 0 ? Math.floor(result.result.clickUv / this.visitPv * 100) : 0;
            console.log("areaHeatmap", this.areaHeatmap);
            //获取div位置
            this.areaTop = (yMax - yMin) / 2 + yMin - 60;
            this.areaLeft = xMax + 50;
            this.areaHeatmapFlag = true;
          }
        }
    }
</script>
<style>
  .area-heatmap-wrapper {
    height: 120px;
    width: 180px;
    background: rgba(0, 0, 0, 0.8);
    position: absolute;
    color: #FFFFFF;
    z-index: 1100;
  }
  .content-wrapper {
    padding: 10px;
  }
</style>